import { useRoute } from 'shared/library/routes/route';
import { View } from 'react-native';
import { Text } from 'shared/components/text';
import tryggHansaLogo from 'shared/assets/brands/trygg-hansa.png';
import { Image } from 'shared/components/image';
import { useTranslation } from 'react-i18next';
import { Link } from 'shared/components/link';
import { Icon } from 'shared/components/icon';
import { listingFeatureIcons } from 'shared/components/listing-feature-icons';

export function ListingLitterInsured() {
  const { t } = useTranslation('components');
  const route = useRoute();

  return (
    <View
      className={
        'border-brand-brown-dark/15 mt-3 items-center gap-3 rounded border bg-white p-3 md:flex-row'
      }
    >
      <View className={'flex-1'}>
        <View className={'flex-row items-center'}>
          <Icon icon={listingFeatureIcons.insurance} className={'text-brand-brown mr-1.5 size-4'} />
          <Text className={'text-brand-brown-dark font-bold'}>
            {t('listing_litter_insured.litter_insured')}
          </Text>
        </View>

        <Text className={'mt-1.5 text-stone-600'}>
          {t('listing_litter_insured.description')}{' '}
          <Link href={route('litter-insurance')} textClassName={'underline'}>
            {t('common:learn_more')}
          </Link>
        </Text>
      </View>

      <Image
        src={tryggHansaLogo}
        alt={'Trygg-Hansa Logo'}
        containerClassName={'aspect-3/1 w-32'}
        imageClassName={'object-contain'}
      />
    </View>
  );
}
